/* eslint-disable @typescript-eslint/no-explicit-any */
import request from '../../../request/request';
import { log } from '../../../utils/notification';

export const getLicense = async (system) => {
  return await request<Request.License, any>(false, 'POST', 'public/tools/license', { system })
    .then(
      (response) => {
        return response?.data ?? null;
      }
    )
    .catch(
      (error) => {
        log('Request (type: License)', { response: error.message }, 'Error');
      }
    );
};